module.exports = __webpack_public_path__ + "img/stock3.cb6300ba.png";